import React from 'react';
import { motion } from 'framer-motion';
function FooterCircuitPattern() {
  return <svg className="absolute inset-0 w-full h-full" xmlns="http://www.w3.org/2000/svg" style={{
    opacity: 0.03
  }} data-id="element-155">
      <defs data-id="element-156">
        <pattern id="circuit-footer" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse" data-id="element-157">
          <path d="M0 40 H30 V20 H50 V60 H80" fill="none" stroke="#C4C4CC" strokeWidth="0.5" data-id="element-158" />
          <path d="M40 0 V30 H60 V50 H40 V80" fill="none" stroke="#C4C4CC" strokeWidth="0.5" data-id="element-159" />
          <circle cx="30" cy="40" r="1.5" fill="#C4C4CC" data-id="element-160" />
          <circle cx="50" cy="20" r="1.5" fill="#C4C4CC" data-id="element-161" />
          <circle cx="40" cy="30" r="1.5" fill="#C4C4CC" data-id="element-162" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#circuit-footer)" data-id="element-163" />
    </svg>;
}
export function Footer() {
  return <footer className="relative w-full bg-[#050508] overflow-hidden" data-id="element-164">
      {/* Red separator line */}
      <motion.div className="w-full h-[1px] bg-[#FF2D2D]/40" initial={{
      scaleX: 0
    }} whileInView={{
      scaleX: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2
    }} data-id="element-165" />

      <div className="relative py-12 md:py-16 px-6 md:px-12" data-id="element-166">
        <FooterCircuitPattern data-id="element-167" />

        <div className="relative z-10 max-w-6xl mx-auto flex flex-col md:flex-row items-center md:items-end justify-between gap-6" data-id="element-168">
          <div data-id="element-169">
            <span className="font-['Bebas_Neue'] text-2xl tracking-[0.25em] text-[#C4C4CC] block" data-id="element-170">
              ARCADEUROPE
            </span>
            <span className="text-[#8A8A96] text-sm font-light mt-1 block" data-id="element-171">
              Limassol, Cyprus
            </span>
          </div>

          <span className="text-[#8A8A96] text-xs font-light tracking-wider" data-id="element-172">
            © 2026 Arcadeurope. All rights reserved.
          </span>
        </div>
      </div>
    </footer>;
}